module.exports = {
  getColor: (Color) => {
  // trim, lowercase, replace '/' with spaces, and split by special characters
  let theColor = String(Color).trim().toLowerCase().replace(/\//g, ' ').replace(/[^a-z0-9\s]/g, '');

  const colorGroups = {
    Yellow: ['yellow'],
    Orange: ['orange'],
    Silver: ['silver', 'k23', 'liquid platinum'],
    Blue: ['blue', 'blu', 'navy', 'bluestone', 'deep ocean', 'dark blue', 'light blue', 'nightfall mica'],
    Green: ['green', 'northern lights', 'daq', 'tactical green', 'tactical g'],
    Black: ['black', 'ash', 'blac', 'charcoal', 'espresso', 'obsidian rush', 'charcoal', 'graphite',
    'ebony', 'titan black', 'ebony accents', 'shale', 'dan'],
    Red: ['red', 'red accent', 'scarlet ember tintcoat', 'scarlet em'],
    Gray: ['gray', 'grey', 'light gray', 'light grey', 'titanium gray', 'cement', 'steel', 
    'kbz', 'kby', 'kad', 'boulder gr','gun', 'sterling metallic', 'm7', 'light smoked truffle'],
    White: ['white', 'ivory', 'alpine metallic', 'alpine', 'parchment', 'qbe', 'qac', 'fresh powder', 
    'everest wh', 'wht', 'qm1'],
    Brown: ['brown', 'chestnut', 'sand beige', 'shetland beige', 'beige', 'tan', 'cashmere',
    'sport', 'wheat', 'bronze', 'champagne', 'almond','chai', 'chesnut',
    'sandstone', 'camel', 'sahara stone', 'cognac', 'sv premium', 'baja storm', 'cbf', 'canyon bro']
  };

    // look for substring match (e.g., charcoal black)
    for (const [label, values] of Object.entries(colorGroups)) {
      if (values.some(value => theColor.includes(value.toLowerCase()))) {
        return label.replace(/([A-Z])/g, ' $1').trim();
      }
    }

  // default or fallback
  return 'Other';
},
  getMileage: (mileage,range) => {
    range = (range != null ? range : 10000)
    return Math.ceil(parseInt(mileage) / range) * range
  },
  getCost: (cost,range) => {
    range = (range != null ? range : 5000)
    return Math.ceil(parseInt(cost) / range) * range
  },
  getTransmissionType: (Transmission) => {
    if (Transmission.includes('Automatic')) {
      return 'Automatic'
    } else if (Transmission.includes('Manual')) {
      return 'Manual'
    } else {
      return Transmission
    }
  },
  getFuelType: (Fuel) => {
    if(Fuel.includes('Gas') && Fuel.includes('Electric')){
      return 'Hybrid'
    }else if (Fuel.includes('Electric')){
      return 'Electric'
    }else if(Fuel.includes('Diesel')){
      return 'Diesel'
    }else if (Fuel.includes('Gas') || Fuel.includes('Unleaded')){
      return 'Gas'
    }else {
      return 'Other'
    }

  }
}

